// tslint:disable:max-line-length

import React from 'react';

export const ActionComment = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0 0v12h12l4 4v-16h-16z" />
    </svg>
  );
};
